import React, { useEffect, useState } from "react";
import "./OrderPage.css";
import "../Cart/cartitems.css";
import "../vendor/vendor.css";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { baseurl } from "../CoocpeatHome";
import { Oval } from "react-loader-spinner";
import Cookies from "js-cookie";
// import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import { IoInformationCircleOutline } from "react-icons/io5";


function OrderPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { id, existingCart } = location.state || {};
  // console.log(location.state, "vendor id in order page");

  const [cart, setCart] = useState({});
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [showDescription, setShowDescription] = useState(false);


  const fetchProducts = async () => {
    try {
      setLoading(true);
      const res = await axios.get(`${baseurl}products/getproduct`, {
        params: { vendorId: id },
      });
      setProducts(res.data.products || []);
    } catch (error) {
      console.log(error, "error from get vendor products");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (existingCart && Object.keys(existingCart).length > 0) {
      setCart(existingCart);
    }
    fetchProducts();
  }, []);

  const handleAdd = (id) => {
    setCart((prev) => ({
      ...prev,
      [id]: (prev[id] || 0) + 1,
    }));
  };

  const handleRemove = (id) => {
    setCart((prev) => {
      const newCart = { ...prev };
      if (newCart[id] > 1) newCart[id] -= 1;
      else delete newCart[id];
      return newCart;
    });
  };

  const totalItems = Object.values(cart).reduce((a, b) => a + b, 0);
  const totalPrice = Object.entries(cart).reduce((sum, [id, qty]) => {
    const product = products.find((p) => p.productId === id);
    return product ? sum + product.productprice * qty : sum;
  }, 0);

  const handleCartItems = async () => {
    try {
      setSubmitting(true); // ✅ Start loader
      const resp = await axios.post(baseurl + "products/addedCartItems", {
        userId: Cookies.get("userId"),
        cart,
      });

      if (resp.status === 200) {
        navigate("/Cart");
      } else {
        alert("Failed to add items to cart. Please try again.");
      }
    } catch (err) {
      console.error("Error while adding to cart:", err);
      alert("Something went wrong. Please try again.");
    } finally {
      setSubmitting(false); // ✅ Stop loader
    }
  };

  return (
    <div className='backcolour'>
      <div className="order-page">
        <header className="cart-header">
          <img
            src={require("../../asset/CocopeatAssests/Arrow Pointing Left.png")}
            alt="back"
            onClick={() => navigate('/Order')}
          />
          <h2 className="fontDG">Products</h2>
        </header>

        {loading ? (
          <div className="loader-container">
            <Oval height={50} width={50} color="#3498db" ariaLabel="loading" />
          </div>
        ) : (
          <div className="order-content">
            <div className="product-grid">
              {products.map((product) => {
                const quantity = cart[product.productId] || 0;
                return (
                  <div key={product.productId} className="product-card">
                    <img
                      src={product.productimg}
                      alt={product.productname}
                      className="product-image"
                    />
                    <p className="product-name">{product.productname}</p>

                    <button
                      onClick={() => setShowDescription(!showDescription)}
                      style={{ fontSize: "24px", cursor: "pointer", background: "none", border: "none" }}
                    >
                      <IoInformationCircleOutline />
                    </button>
                    {showDescription && (
                      <p className="productDescription">{product.description}</p>
                    )}

                    <div className="Price-bar">
                      <div className="innerbar">
                        <p className="product-price">
                          Rs.{product.productprice} /-
                        </p>
                      </div>

                      {quantity > 0 ? (
                        <div className="qty-controls">
                          <button onClick={() => handleRemove(product.productId)}>
                            -
                          </button>
                          <span>{quantity}</span>
                          <button onClick={() => handleAdd(product.productId)}>
                            +
                          </button>
                        </div>
                      ) : (
                        <button
                          className="add-button"
                          onClick={() => handleAdd(product.productId)}
                        >
                          ADD
                        </button>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {totalItems > 0 && (
          <div className="cart-section">
            <div className="cart-total">
              <p className="discounted-price">Rs.{totalPrice}</p>
            </div>
            <div className="cart-actions">
              <div className="cart-items">{totalItems} pcs</div>
              <button
                className="go-cart-button"
                onClick={handleCartItems}
                disabled={submitting} // ✅ disable button when loading
              >
                {submitting ? (
                  <Oval
                    height={20}
                    width={20}
                    color="#fff"
                    secondaryColor="#ccc"
                    strokeWidth={4}
                  />
                ) : (
                  "Go to Cart"
                )}
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default OrderPage;
